export default "https://cdn-static.gokick.com/assets/7f5563240f0a87948aacfb3375d791c4357d9b8c/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";